import { SidebarItem } from '@treedis/tour-loader';

export const Book = ({ isDrawerOpen, onToggle, translation }: any) => {
  const { book: bookLabel = 'Book' } = translation;
  return (
    <SidebarItem
      isOpen={isDrawerOpen}
      popupLabel={bookLabel}
      button={{
        label: bookLabel,
        tooltip: bookLabel,
        icon: 'fa-book',
        onClick: onToggle,
      }}
    />
  );
};
